/**
 * @generated SignedSource<<fd82fed760ee0e73234dabc1ba486f26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
export type useWidgetTaskSingleSubscription$variables = {
  routineIds: ReadonlyArray<string>;
  taskIds: ReadonlyArray<string>;
};
export type useWidgetTaskSingleSubscription$data = {
  readonly routineTaskExecutionChanged: {
    readonly checkValue?: TaskSentiment | null;
    readonly formattedNumberValue?: string | null;
    readonly id?: string;
    readonly numberValue?: number | null;
    readonly updatedAt?: string | null;
  } | null;
};
export type useWidgetTaskSingleSubscription = {
  response: useWidgetTaskSingleSubscription$data;
  variables: useWidgetTaskSingleSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routineIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "taskIds"
},
v2 = [
  {
    "kind": "Variable",
    "name": "routineIds",
    "variableName": "routineIds"
  },
  {
    "kind": "Variable",
    "name": "taskIds",
    "variableName": "taskIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberValue",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedNumberValue",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useWidgetTaskSingleSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "TaskExecutionNumber",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v7/*: any*/),
              (v6/*: any*/)
            ],
            "type": "TaskExecutionCheck",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useWidgetTaskSingleSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "routineTaskExecutionChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "TaskExecutionNumber",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v6/*: any*/)
            ],
            "type": "TaskExecutionCheck",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "798f49e48699c47dd2dbe9fdb360b8f7",
    "id": null,
    "metadata": {},
    "name": "useWidgetTaskSingleSubscription",
    "operationKind": "subscription",
    "text": "subscription useWidgetTaskSingleSubscription(\n  $taskIds: [ID!]!\n  $routineIds: [ID!]!\n) {\n  routineTaskExecutionChanged(routineIds: $routineIds, taskIds: $taskIds) {\n    __typename\n    ... on TaskExecutionNumber {\n      id\n      numberValue\n      formattedNumberValue\n      updatedAt\n    }\n    ... on TaskExecutionCheck {\n      id\n      checkValue\n      updatedAt\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "690019c9349de466aee67751c4d86293";

export default node;
